import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import omorelogo from "../Images/OMG.svg";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();

const getModuleName = () => {
    const path = location.pathname;

    // Direct Mappings
    if (path === "/") return "NEURALIS";
    if (path.includes("about")) return "STUDIO";
    if (path.includes("contact")) return "CONTACT";
    if (path.includes("terms")) return "TERMS";
    if (path.includes("privacy")) return "PRIVACY";
    
    // Dynamic Game Names (e.g., /game/reflex-test -> REFLEX-TEST)
    if (path.includes("game")) {
      return path.split("/").pop().toUpperCase().replace(/-/g, " ");
    }

    return "OMORE";
  };

  const moduleName = getModuleName();

  return (
    <footer className="pt-16 pb-10 border-t border-zinc-900 mt-auto select-none bg-transparent">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col gap-12">
        
        {/* TOP */}
        <div className="flex flex-col lg:flex-row justify-between items-start gap-12">
          
          {/* LEFT */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-8 md:gap-12 w-full lg:w-auto">
            
            {/* STUDIO */}
            <div className="flex flex-col items-start gap-4">
              <div className="flex items-center gap-3 ml-1">
                <div className="h-[1px] w-3 bg-blue-600/50" />
                <p className="text-[9px] tracking-[0.4em] uppercase font-bold text-zinc-200">
                  Studio
                </p>
              </div>

              <a 
                href="https://omore.games" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-4 group cursor-pointer"
              >
                <div className="relative flex items-center justify-center w-14 h-14 bg-zinc-950 border border-white/10 rounded-xl transition-all duration-500 group-hover:border-blue-500/40 group-hover:shadow-[0_0_20px_rgba(59,130,246,0.15)] overflow-hidden">
                  <img 
                    src={omorelogo} 
                    alt="Logo" 
                    className="h-7 w-auto object-contain transition-transform duration-500 group-hover:scale-110" 
                  />
                  <div className="absolute inset-0 bg-gradient-to-tr from-blue-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>

                <div className="flex flex-col">
                  <h4 className="text-sm tracking-[0.2em] font-black text-zinc-200 group-hover:text-white transition-colors uppercase">
                    OMORE GAMES
                  </h4>

                  <span className="text-[8px] tracking-[0.1em] text-zinc-600 uppercase font-medium mt-0.5">
                    Interactive Reflex Studio
                  </span>
                </div>
              </a>
            </div>

            {/* DIVIDER */}
            <div className="h-12 w-px bg-zinc-800/50 hidden sm:block" />

            {/* MODULE */}
            <div className="flex flex-col">
              <p className="text-[9px] tracking-[0.4em] uppercase font-bold text-zinc-200 mb-3">
                Active Module
              </p>

              <div className="flex items-center gap-3">
                <div className="w-1 h-1 bg-blue-500 rounded-full animate-pulse shadow-[0_0_8px_#3b82f6]" />

                <h4 className="text-xs md:text-sm tracking-[0.3em] font-black text-blue-500 uppercase">
                  {moduleName}
                </h4>
              </div>
            </div>
          </div>

          {/* NAV */}
          <nav className="grid grid-cols-2 sm:flex sm:flex-wrap items-center gap-x-10 gap-y-5 w-full lg:w-auto">
            {[
              { name: "About", path: "/aboutomore" },
              { name: "Library", path: "/gamelibrary" },
              { name: "Contact", path: "/contact" },
              { name: "Terms", path: "/terms" },
              { name: "Privacy", path: "/privacy" },
            ].map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="text-[10px] tracking-[0.25em] uppercase font-bold text-zinc-200 hover:text-white transition-all duration-300 relative group"
              >
                {link.name}

                <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-blue-500 transition-all duration-300 group-hover:w-full" />
              </Link>
            ))}
          </nav>
        </div>

        {/* BOTTOM */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-zinc-900/50 gap-6">
          <p className="text-[9px] tracking-[0.3em] text-zinc-600 uppercase font-medium order-2 md:order-1">
            &copy; {currentYear} OMORE GAMES. 
            <span className="hidden sm:inline"> ALL RIGHTS RESERVED.</span>
          </p>
          
          <div className="flex items-center gap-6 order-1 md:order-2">

            <div className="flex items-center gap-2.5">
              <span className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse shadow-[0_0_10px_#22c55e]" />
              <span className="text-[9px] tracking-[0.2em] text-zinc-400 uppercase font-bold">
                System Online
              </span>
            </div>

            <div className="h-3 w-px bg-zinc-800" />

            <p className="text-[9px] tracking-[0.2em] text-zinc-600 uppercase font-medium">
              Precision Optimized
            </p>

          </div>
        </div>

        {/* SEPARATOR */}
        <div className="h-px w-24 mx-auto bg-zinc-800/60" />

        {/* MOTTO */}
        <div className="text-center">
          <p className="text-[9px] md:text-[11px] tracking-[0.4em] md:tracking-[0.7em] uppercase text-zinc-700 font-bold italic opacity-60">
            Challenge your limits. Sync your mind. Master the reflex.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;